import {
  Meta,
  WappMode,
  WappInput,
  CustomAction,
} from '@weblite-wapps/protocol'

// eslint-disable-next-line no-shadow
export enum WappCondition {
  RUN_WAPP = 'run-wapp',
  RECEIVE_MESSAGE = 'receive-message',
  SHOW_LOADING = 'show-loading',
}

// eslint-disable-next-line no-shadow
export enum WappStage {
  LOADING = 'loading',
  RUNNING = 'running',
}

export class WappSessionCreator {
  wappSessionId?: string
  wappId: string
  wisId?: string
  mode: WappMode
  input?: WappInput
  parentWapp?: Meta
}

export interface BookmarkData {
  contentUri: string
  cover: string
}

export class WappSession extends WappSessionCreator {
  wappSessionId: string
  elementName: string
  output?: unknown
  stage: WappStage
  servIndexes: Record<WappMode, string>
  customActions?: CustomAction[]
  bookmarkData?: BookmarkData
}
